<template>
  <page-article
    :page-title="currentJobDetailsGetter.job_title"
    :attachments="currentJobDetailsGetter.job_attachments"
  >
    <template slot="meta">
      <div class="col-5">
        <div class="row">
          <div class="col-4">
            <font-awesome-icon icon="calendar-alt" />
            {{ currentJobDetailsGetter.job_published_at || new Date() | moment("YYYY/MM/DD") }}
          </div>
        </div>
      </div>
    </template>
    <template>
      <div class="page_article_block col-12">
        <ul class="article_info_list">
          <li class="article_info_item">
            <span class="article_tag">公司名稱</span>
            {{ currentJobEnterpriseGetter.enterprise_name }}
          </li>
          <li
            class="article_info_item"
          >
            <span class="article_tag">公司logo</span>
            <img
              :src="currentJobEnterpriseGetter.enterprise_logo.attachment_url"
              class="enterprise_logo img-fluid rounded-circle img-thumbnails"
              :alt="currentJobEnterpriseGetter.enterprise_name"
            >
          </li>
          <li class="article_info_item">
            <span class="article_tag">產業類別</span>
            {{ categoriesGetter.find(industry => industry.category_value === currentJobEnterpriseGetter.enterprise_industry).category_name }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">產業描述</span>
            {{ currentJobEnterpriseGetter.enterprise_name }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">員工人數</span>
            {{ currentJobEnterpriseGetter.enterprise_employee_number }}
	    人
          </li>
          <li class="article_info_item">
            <span class="article_tag">資本額</span>
            {{ currentJobEnterpriseGetter.enterprise_registered_capital }}
          萬
</li>
          <li class="article_info_item">
            <span class="article_tag">聯絡人</span>
            {{ currentJobEnterpriseGetter.enterprise_contact_person }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">公司地址</span>
            {{ currentJobEnterpriseGetter.enterprise_address }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">電話</span>
            {{ currentJobEnterpriseGetter.enterprise_tel }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">傳真</span>
            {{ currentJobEnterpriseGetter.enterprise_fax }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">網址</span>
            {{ currentJobEnterpriseGetter.enterprise_website }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">公司介紹</span>
            {{ currentJobEnterpriseGetter.enterprise_introduction }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">福利制度</span>
            {{ currentJobEnterpriseGetter.enterprise_employee_benefits }}
          </li>
        </ul>
      </div>
    </template>
  </page-article>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import pageArticle from '~components/pages/Article'
export default {
  name: 'JobOpeningEnterpriseContent',
  components: {
    pageArticle
  },
  computed: {
    ...mapGetters('pages/jobs', [
      'currentJobDetailsGetter',
      'currentJobEnterpriseGetter',
      'categoriesGetter'
    ])
  },
  async created () {
    await this.getCategories()
	try {
		await this.getJobDetailsById(this.$route.params.id)
	} catch (err) {
		this.$router.push('/job-opening/zh');
	}
  },
  methods: {
    ...mapActions('pages/jobs', [
      'getJobDetailsById',
      'getCategories'
    ])
  }
}
</script>
<style lang="scss" scoped>
.enterprise_logo {
  max-height: 150px;
}
</style>
